import { LOGIN_REQUEST, LOGIN_RESPONCE, LOGIN_ERROR, CLEAR_LOGIN_INFO} from './../constants';


export default function(state={}, action) {
    switch(action.type) {
        case LOGIN_REQUEST: 
            return {
                ...state,
                loading: true,
                mobile: action.data,
                response: null,
                errInfo: null,
                err: false
            }
        case LOGIN_RESPONCE: 
            return {
                ...state,
                loading: false,
                response: action.res,
                err: false
            }
        case LOGIN_ERROR: 
            return {
                ...state,
                err: true,
                errInfo: action.err,
                loading: false
            }
        case CLEAR_LOGIN_INFO: 
            return {}
        default: return state;
    }
}

 